import { I18n } from '@calendly/i18n'

// i18n-tasks-use t('publisher.event_type_editor.sections.scheduling_settings.additional_options.increments.hours')
// i18n-tasks-use t('publisher.event_type_editor_crud.availability.start_interval_option.hours')
// i18n-tasks-use t('publisher.event_type_editor_crud.availability.start_interval_option.minutes')

const getLegacySummary = ({ spotStep, customSpotStep, customSpotStepType }) => {
  if (spotStep === 'custom' && customSpotStep) {
    if (customSpotStepType === 'hours') {
      return I18n.t('publisher.event_type_editor.sections.scheduling_settings.additional_options.increments.hours',
        { step: customSpotStep })
    }

    return I18n.t('publisher.event_type_editor.sections.scheduling_settings.additional_options.increments.minutes',
      { step: customSpotStep })
  }

  return I18n.t('publisher.event_type_editor.sections.scheduling_settings.additional_options.increments.minutes',
    { step: spotStep })
}

const getV3Summary = ({ spotStep, customSpotStep, customSpotStepType }) => {
  if (spotStep === 'custom' && customSpotStep) {
    const count = Number(customSpotStep)

    if (customSpotStepType === 'hours') {
      return I18n.t('publisher.event_type_editor_crud.availability.start_interval_option.hours',
        { count, step: customSpotStep })
    }

    return I18n.t('publisher.event_type_editor_crud.availability.start_interval_option.minutes',
      { count, step: customSpotStep })
  }

  const count = Number(spotStep)

  return I18n.t('publisher.event_type_editor_crud.availability.start_interval_option.minutes',
    { count, step: spotStep })
}

export const getSummary = ({ spotStep, customSpotStep, customSpotStepType, v3Style = false }) => {
  if (spotStep === 'custom' && !customSpotStep) {
    return I18n.t('publisher.event_type_editor.sections.scheduling_settings.not_set')
  }

  return v3Style
    ? getV3Summary({ spotStep, customSpotStep, customSpotStepType })
    : getLegacySummary({ spotStep, customSpotStep, customSpotStepType })
}
